export type AllowedButtonsSections = {
  showChatBot: boolean;
  showNews: boolean;
  showAllRankings: boolean;
  showRosters: boolean;
  showTrades: boolean;
  showTeamAnalysis: boolean;
  showStart: boolean;
  showWaiver: boolean;
  showDraftAdvice: boolean;
  showArticles: boolean;
  disabledPlatformDraftAdvice: string[];
};

// Get which Home sections/buttons should be visible (backend-controlled feature flags).
export const getAllowedButtonsSections = async (
  accessAuthToken: string,
  pocToken: string
): Promise<AllowedButtonsSections> => {
  try {
    const requestBody = {
      pocToken: pocToken,
    };

    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/allowed_buttons_sections`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessAuthToken}`,
      },
      body: JSON.stringify(requestBody),
      credentials: "include",
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch allowed buttons/sections: ${response.statusText}`);
    }

    const data = await response.json();
    return {
      ...data,
      showArticles: data.showArticles ?? true,
      disabledPlatformDraftAdvice: data.disabledPlatformDraftAdvice ?? [],
    };
  } catch (error) {
    console.error("Error fetching allowed buttons/sections:", error);

    // Defaults to true to avoid breaking the UI.
    return {
      showChatBot: true,
      showNews: true,
      showAllRankings: true,
      showRosters: true,
      showTrades: true,
      showTeamAnalysis: true,
      showStart: true,
      showWaiver: true,
      showDraftAdvice: true,
      showArticles: true,
      disabledPlatformDraftAdvice: [],
    };
  }
};

